import React from 'react'
import classNames from 'classnames'
import { InternalLink } from '@/atoms/InternalLink'
import { useIsDarkMode } from '@/contexts/ThemeContext'
import { BaseAlgoliaRecord } from '@/search/types'
import { BaseSearchHitProps } from './types'

interface Props extends BaseSearchHitProps<BaseAlgoliaRecord> {
  children: React.ReactNode
}

export const BaseSearchHit: React.FC<Props> = ({ children, hit }) => {
  const isDarkMode = useIsDarkMode()

  return (
    <article
      className={classNames(
        'md:px-4 relative transition-bg',
        isDarkMode ? 'hover:bg-core-gray-800' : 'hover:bg-core-gray-100',
      )}
    >
      <div className="h-full w-full p-2">
        <InternalLink className="cursor-pointer" href={hit.url}>
          <div className="flex flex-row items-center gap-6 py-2">{children}</div>
        </InternalLink>
      </div>
    </article>
  )
}
